// to do: remove adv, acc, pub, website, from table search ;
import React, { Component } from 'react';
import get from 'lodash/get';
import pick from 'lodash/pick';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
import Select from 'react-select';
import { Admin as Layout } from '../../../../components/layouts';
import { Spinner, DateRange } from '../../../../components/common';
import { AdminApi } from '../../../../api';
import StatCards from '../../../../components/admin/publisher/reports/StatCards';
import { findPredicate } from '../../../../utils/helpers/filter_conversions';
import { humanize } from '../../../../utils/helpers/text_formatters';
import ExportCSVButton from '../../../../components/common/ExportCSVButton';
import { calendarRanges } from '../../../../utils/helpers/calendar_ranges';
import { formatData } from '../../../../utils/helpers/admin/table_formatters';

class AdminReportsPubIndex extends Component {
  componentWillMount() {
    this.fetchResource();
  }

  getDropdownFilters(selectedValue) {
    const { companyType, entityType, selectedCompany, selectedEntity, selectedNetworkType, selectedSalesRep, selectedCountryCode } = this.props;
    const filters = {
      [companyType]: selectedCompany ? selectedCompany : {},
      [entityType]: selectedEntity ? selectedEntity : {},
      network_type: selectedNetworkType ? selectedNetworkType : {},
      sales_rep: selectedSalesRep ? selectedSalesRep : {},
      country_code: selectedCountryCode ? selectedCountryCode : {},
      ...selectedValue,
    };

    return filters;
  }

  fetchResource(params = {}) {
    const { resourceName, dispatch, companyOptions } = this.props;
    dispatch(AdminApi.actions[resourceName](params));
    dispatch(AdminApi.actions.publisherReportStats(params));
    if (!companyOptions) {
      dispatch(AdminApi.actions.publisherReportDropdown());
    }
  }

  handleOnPageChange(page, per_page) {
    const { companyType } = this.props;

    this.fetchResource({
      page,
      per_page,
      filters: get(this.props, 'resource.meta.filters', {}),
      sort: get(this.props, 'resource.meta.sort', {}),
      start_date: get(this.props, 'resource.meta.start_date', moment().startOf('month').format()),
      end_date: get(this.props, 'resource.meta.end_date', moment().format()),
      group_by: get(this.props, 'resource.meta.group_by', companyType),
    });
  }

  columnWidth(field) {
    switch (field) {
      case 'publisher':
      case 'advertiser':
      case 'website':
      case 'account':
      case 'campaign':
      case 'excluded_conversions':
      case 'click_fraud_percent':
        return '180';
      case 'total_conversions':
      case 'profit_percent':
      case 'expired_amount':
      case 'excluded_amount':
      case 'duplicate_amount':
      case 'over_budget_clicks':
        return '160';
      case 'country_code':
      case 'total_amount':
      case 'fraud_amount':
      case 'sales_rep_name':
      case 'fraud_clicks':
      case 'expired_clicks':
      case 'excluded_clicks':
      case 'sandbox_clicks':
      case 'latent_clicks':
      case 'foreign_clicks':
      case 'duplicate_clicks':
      case 'video_views':
        return '140';
      case 'impressions':
      case 'conversions':
      case 'video_earned':
      case 'video_spend':
        return '120';
      case 'total_earned':
      case 'total_spend':
      case 'total_clicks':
        return '115';
      case 'bid_type':
        return '90';
      case 'acpv':
      case 'acpc':
      case 'acpa':
      case 'ctr':
      case 'earned':
      case 'spend':
      case 'clicks':
        return '80';
      default:
        return '100';
    }
  }

  handleDateApply(d) {
    const { companyType } = this.props;

    this.fetchResource({
      start_date: d.startDate.format(),
      end_date: d.endDate.format(),
      id: this.props.id,
      filters: get(this.props, 'resource.meta.filters', {}),
      page: get(this.props, 'resource.meta.pagination.page', 1),
      per_page: get(this.props, 'resource.meta.pagination.per_page', 10),
      sort: get(this.props, 'resource.meta.sort', {}),
      group_by: get(this.props, 'resource.meta.group_by', companyType),
    });
  }

  handleGroupByApply({ value }) {
    this.fetchResource({
      start_date: get(this.props, 'resource.meta.start_date', moment().startOf('month').format()),
      end_date: get(this.props, 'resource.meta.end_date', moment().format()),
      id: this.props.id,
      filters: get(this.props, 'resource.meta.filters', {}),
      page: get(this.props, 'resource.meta.pagination.page', 1),
      per_page: get(this.props, 'resource.meta.pagination.per_page', 10),
      sort: get(this.props, 'resource.meta.sort', {}),
      group_by: value,
    });
  }

  handleOnSortChange(field, order) {
    const { companyType } = this.props;
    const sort = { field, order };

    this.fetchResource({
      page: get(this.props, 'resource.meta.pagination.page', 1),
      per_page: get(this.props, 'resource.meta.pagination.per_page', 10),
      filters: get(this.props, 'resource.meta.filters', {}),
      sort,
      start_date: get(this.props, 'resource.meta.start_date', moment().startOf('month').format()),
      end_date: get(this.props, 'resource.meta.end_date', moment().format()),
      group_by: get(this.props, 'resource.meta.group_by', companyType),
    });
  }

  handleOnFilterChange(e) {
    const { selectedStartDate, selectedEndDate } = this.props;
    const filters = {};

    Object.entries(e).forEach(([field, properties]) => {
      switch (properties.type) {
        case 'TextFilter': {
          const {
            value,
            props: { cond },
          } = properties;
          filters[field] = { value, predicate: cond || 'eq' };
          break;
        }
        case 'NumberFilter': {
          const {
            value: { comparator, number },
          } = properties;
          filters[field] = { value: number, predicate: findPredicate(comparator) };
          break;
        }
        case 'DateFilter': {
          const {
            value: { comparator, date },
          } = properties;
          filters[field] = { value: date, predicate: findPredicate(comparator) };
          break;
        }
        case 'SelectFilter': {
          const { value } = properties;
          filters[field] = { value, predicate: 'eq' };
          break;
        }
        default:
          break;
      }
    });

    setTimeout(() => {
      const { companyType } = this.props;

      this.fetchResource({
        page: get(this.props, 'resource.meta.pagination.page', 1),
        per_page: get(this.props, 'resource.meta.pagination.per_page', 10),
        filters,
        sort: get(this.props, 'resource.meta.sort', {}),
        start_date: selectedStartDate.format(),
        end_date: selectedEndDate.format(),
        group_by: get(this.props, 'resource.meta.group_by', companyType),
      });
    }, 500);
  }

  handleFilterCreation(filterHash) {
    const filters = {};
    Object.entries(filterHash).forEach(([key, value]) => {
      filters[key] = {
        value,
        type: 'SelectFilter',
        props: { cond: 'like' },
      };
    });
    return filters;
  }

  handleCompanyChange(company) {
    const { companyType } = this.props;
    let filters = {};

    if (company) {
      filters = this.getDropdownFilters({ [companyType]: company.value });
    } else {
      filters = this.getDropdownFilters({ [companyType]: '' });
    }
    this.table.handleFilterData(this.handleFilterCreation(filters));
  }

  handleEntityChange(entity) {
    const { entityType } = this.props;
    let filters = {};

    if (entity) {
      filters = this.getDropdownFilters({ [entityType]: entity.value });
    } else {
      filters = this.getDropdownFilters({ [entityType]: '' });
    }
    this.table.handleFilterData(this.handleFilterCreation(filters));
  }

  handleNetworkTypeChange(networkType) {
    let filters = {};

    if (networkType) {
      filters = this.getDropdownFilters({ network_type: networkType.value });
    } else {
      filters = this.getDropdownFilters({ network_type: 0 });
    }
    this.table.handleFilterData(this.handleFilterCreation(filters));
  }

  handleCountryCodeChange(countryCode) {
    let filters = {};

    if (countryCode) {
      filters = this.getDropdownFilters({ country_code: countryCode.value });
    } else {
      filters = this.getDropdownFilters({ country_code: 'US' });
    }
    this.table.handleFilterData(this.handleFilterCreation(filters));
  }

  handleSalesRepChange(salesRep) {
    let filters = {};

    if (salesRep) {
      filters = this.getDropdownFilters({ sales_rep: salesRep.value });
    } else {
      filters = this.getDropdownFilters({ sales_rep: '' });
    }
    this.table.handleFilterData(this.handleFilterCreation(filters));
  }

  render() {
    const {
      resourceName,
      resource,
      isLoading,
      grossStats,
      companyOptions,
      entityOptions,
      salesRepOptions,
      selectedCompany,
      selectedGroupBy,
      selectedEntity,
      selectedNetworkType,
      selectedCountryCode,
      selectedSalesRep,
      selectedStartDate,
      selectedEndDate,
      entityType,
      columnAttributes,
    } = this.props;
    const { data, meta } = resource || {};
    const { filters } = meta || {};
    const { pagination, column_info, sort } = meta || {};
    const index = get(column_info, 'index_page', []);

    if (index.length > 1) index.move(index.indexOf('uuid'), 0);

    const CSVButton = () => {
      return (
        <ExportCSVButton
          resourceName={resourceName}
          filters={filters}
          start_date={selectedStartDate.format()}
          end_date={selectedEndDate.format()}
          group_by={selectedGroupBy}
        />
      );
    };

    const options = {
      exportCSVBtn: CSVButton,
      onFilterChange: this.handleOnFilterChange.bind(this),
      onSortChange: this.handleOnSortChange.bind(this),
      sortName: get(sort, 'field', 'id'),
      sortOrder: get(sort, 'order', 'desc'),
      defaultSortName: get(sort, 'field', 'ctr'),
      defaultSortOrder: get(sort, 'order', 'desc'),
      sizePerPage: get(pagination, 'per_page', 10),
      onPageChange: this.handleOnPageChange.bind(this),
      sizePerPageList: [10, 20, 50, 100],
      pageStartIndex: 1,
      page: get(pagination, 'current_page', 1),
    };

    const fetchInfo = {
      dataTotalSize: get(pagination, 'total_count', 0),
    };

    const passProps = pick(this.props, ['routeParams', 'location', 'routes']);

    const networkTypeOptions = [
      { value: 0, label: 'All Network Types' },
      { value: 1, label: 'Website' },
      { value: 2, label: 'Email' },
      { value: 3, label: 'Feed' },
    ];
    const countryCodeOptions = [
      { value: 'US', label: 'US' },
      { value: 'CA', label: 'CA' },
    ];
    const groupByOptions = [
      { value: 'publisher', label: 'Publisher Reports' },
      { value: 'website', label: 'Website Reports' },
    ];

    return (
      <Layout {...passProps}>
        <div className="ibox">
          <div className="ibox-title">
            <h5>{humanize(resourceName)}</h5>
          </div>
          <div className={`ibox-content${isLoading ? ' sk-loading' : ''}`}>
            <Col className="report-search">
              <Row className="reports-date-range">
                <Col md={12}>
                  <div className="pull-left date-padding">
                    <DateRange
                      key="daterange-ad-cu-dash"
                      defaultChosenLabel="This Month"
                      opens="right"
                      startDate={selectedStartDate}
                      endDate={selectedEndDate}
                      ranges={calendarRanges}
                      onApply={this.handleDateApply.bind(this)}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Select
                    value={selectedGroupBy}
                    onChange={this.handleGroupByApply.bind(this)}
                    options={groupByOptions}
                    placeholder="Group by..."
                    className="reports-dropdown"
                    clearable={false}
                  />
                </Col>
                <Col md={2}>
                  <Select
                    value={selectedNetworkType}
                    options={networkTypeOptions}
                    placeholder="Filter network type"
                    onChange={this.handleNetworkTypeChange.bind(this)}
                    className="reports-dropdown"
                  />
                </Col>
                <Col md={2}>
                  <Select
                    value={selectedCountryCode}
                    options={countryCodeOptions}
                    placeholder="Filter country"
                    onChange={this.handleCountryCodeChange.bind(this)}
                    className="reports-dropdown"
                    clearable={false}
                  />
                </Col>
                <Col md={4}>
                  <Select
                    value={selectedSalesRep}
                    onChange={this.handleSalesRepChange.bind(this)}
                    options={salesRepOptions}
                    placeholder="Filter sales rep"
                    className="reports-dropdown"
                  />
                </Col>
                <Col md={4}>
                  <Select
                    value={selectedCompany}
                    onChange={this.handleCompanyChange.bind(this)}
                    options={companyOptions}
                    placeholder="Filter company"
                    className="reports-dropdown"
                  />
                </Col>
                {selectedCompany && (
                  <Col md={4}>
                    <Select
                      value={selectedEntity}
                      onChange={this.handleEntityChange.bind(this)}
                      options={entityOptions}
                      placeholder={`Filter ${entityType}`}
                      className="reports-dropdown"
                    />
                  </Col>
                )}
              </Row>
              <br />
              <Row>
                <StatCards stats={grossStats} />
              </Row>
            </Col>
            <Spinner />
            <BootstrapTable
              exportCSV
              striped
              ref={c => {
                this.table = c;
              }}
              data={data || []}
              remote
              pagination
              fetchInfo={fetchInfo}
              options={options}
            >
              {index.length > 1 ? (
                index.map((field, i) => {
                  const isResourceKey = field === 'uuid';
                  return (
                    <TableHeaderColumn
                      key={`${resourceName}-column-${i}`}
                      isKey={isResourceKey}
                      width={this.columnWidth(field)}
                      dataSort={!isResourceKey}
                      dataField={field}
                      dataFormat={formatData.bind(this, field, columnAttributes)}
                      tdStyle={{ whiteSpace: 'normal' }}
                      thStyle={{ whiteSpace: 'normal' }}
                      hidden={isResourceKey}
                    >
                      {field}
                    </TableHeaderColumn>
                  );
                })
              ) : (
                <TableHeaderColumn isKey dataField={resourceName} />
              )}
            </BootstrapTable>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const resourceName = 'publisherReport';
  const grossStats = state.admin[`${resourceName}Stats`].data.stats;
  const resource = state.admin[resourceName];
  const [companyType, entityType] = ['publisher', 'website'];

  const companyOptions = state.admin[`${resourceName}Dropdown`].data[`${companyType}_dropdown`];
  const entityObject = state.admin[`${resourceName}Dropdown`].data[`${entityType}_dropdown`] || {}; // keys: advertisers/publishers, values: array of their websites/accounts
  const salesRepOptions = state.admin[`${resourceName}Dropdown`].data.sales_rep_dropdown;

  const metaStartDate = get(resource, 'data.meta.start_date', null);
  const metaEndDate = get(resource, 'data.meta.end_date', null);
  const selectedStartDate = metaStartDate ? moment(metaStartDate) : moment().startOf('month');
  const selectedEndDate = metaEndDate ? moment(metaEndDate) : moment();

  const selectedCompany = get(resource, `data.meta.filters[${companyType}].value`, '');
  const selectedGroupBy = get(resource, 'data.meta.group_by', companyType);
  const selectedEntity = get(resource, `data.meta.filters[${entityType}].value`, '');
  const selectedSalesRep = get(resource, 'data.meta.filters.sales_rep.value', '');
  const selectedCountryCode = get(resource, 'data.meta.filters.country_code.value', 'US');
  const selectedNetworkType = parseInt(get(resource, 'data.meta.filters.network_type.value', 0), 10);

  const entityOptions = selectedCompany ? entityObject[selectedCompany] : [];
  const columnAttributes = get(resource, 'data.meta.column_info.attributes', {});

  return {
    resourceName,
    resource: resource.data,
    isLoading: resource.loading,
    grossStats,
    companyOptions,
    entityOptions,
    salesRepOptions,
    companyType,
    entityType,
    selectedStartDate,
    selectedEndDate,
    selectedCompany,
    selectedGroupBy,
    selectedEntity,
    selectedSalesRep,
    selectedNetworkType,
    selectedCountryCode,
    columnAttributes,
  };
};
export default connect(mapStateToProps)(AdminReportsPubIndex);
